














































import { Component, Vue, Prop } from 'vue-property-decorator';
import {SignupQuery,SignupResult, SignupPartnerQuery,signupPurposeFlags,signupUserCountFlags,signupScheduleFlags} from '@/signup/query';
import {auth} from '@/agiles/common/auth';
import {Editor} from '@/agiles/common/validator';
import {BindItem} from '@/agiles/common/formatter';
import * as Components from '@/agiles/components';
import * as Common from '@/agiles/common';

@Component
export default class SignIn extends Vue {
  public query:SignupQuery = new SignupQuery();
  public editor:Editor = new Editor();
  public isLoading:boolean = true;
  public isSignup:boolean = true;

  public result:string = '';
  public licenseFlagEnabled:boolean = false;
  public card_info = '(未登録)';
  public contract:boolean = false;
  public isPrime:boolean = false;
  public partnerName:string = null;
  public tenantIdToolTip:string = String.format("英数6～10文字(ハイフン可)の会社IDを指定してください。御社用URLのサブドメインとして使用されます。<br>例：\"ABC\"の場合\"{0}\"となります。", window.location.host.replace('signup','ABC'));
  created() {

    this.$api.formatter.initializeConstant('signupPurposeFlags',[new Common.BindItem(signupPurposeFlags.default, ''), new Common.BindItem(signupPurposeFlags.introduction, '初めてシステムを導入したい'), new Common.BindItem(signupPurposeFlags.replace, '既存システムを置き換えたい'), new Common.BindItem(signupPurposeFlags.partner, '取引先へ提案したい')]);   
    this.$api.formatter.initializeConstant('signupUserCountFlags',[new Common.BindItem(signupUserCountFlags.default, ''), new Common.BindItem(signupUserCountFlags.under2, '1～2名'), new Common.BindItem(signupUserCountFlags.over3, '3～9名'), new Common.BindItem(signupUserCountFlags.over10, '10～19名'), new Common.BindItem(signupUserCountFlags.over20, '20～29名'), new Common.BindItem(signupUserCountFlags.over30, '30名以上')]);   
    this.$api.formatter.initializeConstant('signupScheduleFlags',[new Common.BindItem(signupScheduleFlags.default, ''), new Common.BindItem(signupScheduleFlags.soon, 'なるべく早く'), new Common.BindItem(signupScheduleFlags.within3month, '3ヶ月以内'), new Common.BindItem(signupScheduleFlags.within6month, '6ヶ月以内'), new Common.BindItem(signupScheduleFlags.within12month, '1年以内'), new Common.BindItem(signupScheduleFlags.notscheduled, '未定')]);   

    // const params = new URLSearchParams(location.search.toLowerCase());
    // const state = params.get('contract');
    // if(state && state.toLowerCase()=='true') this.contract = true;
    let subdomain = '';
    if (process.env.NODE_ENV == 'production'){
      subdomain = window.location.host.split('.')[0];      
    } else {
      subdomain =process.env.VUE_APP_SUBDOMAIN;
    }

    if (subdomain == 'contract'){
      this.contract = true;
      this.query.isContract = true;
    } 

    this.$api.auth = auth;
    this.query.tenantAdminId = this.$api.auth.userId;
    this.$api.formatter.initializeConstant('sampleData', [new BindItem(false, ''),new BindItem(true, '登録する')]);    
    this.$api.formatter.initializeConstant('shipmentFlags', [new Common.BindItem(1, '～20件'),new Common.BindItem(2, '21～50件'),new Common.BindItem(3, '51～100件'),new Common.BindItem(4, '101～500件'),new Common.BindItem(5, '501件～')]);       
    this.$api.formatter.initializeConstant('functionFlags', [new Common.BindItem(2, '在庫管理'),new Common.BindItem(4, '運用管理'),new Common.BindItem(8, '受発注管理')]);

    const params = new URLSearchParams(location.search);
    this.query.partnerKey = params.get('p');
    this.$api.execute(new SignupPartnerQuery(this.query.partnerKey))
    .then(res => this.partnerName = res)
    .then(()=> this.$api.formatter.ensureListLoaded('licenseFlags','templateFlags'))
    .then(()=>{
      this.isLoading =false;
      this.licenseFlagEnabled = this.$api.formatter.getOptions("licenseFlags").length > 1;
      this.query.licenseFlag = this.$api.formatter.getOptions("licenseFlags")[0].value;
      this.isPrime = (this.query.licenseFlag & Common.licenseFlags.prime) != 0;
      })    ;

      //グーグルタグマネージャーの挿入
      let script = document.createElement('script');
      script.innerText = "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-MLMVZVB');";
      document.head.appendChild(script);      

      //Intercomのロード
      (window as any).intercomSettings = {
        app_id: 'e1fkao87',
        // name: this.$api.auth.userName, // 氏名に変更
        email: this.$api.auth.userId, // Email address
        // user_id: this.$api.auth.userId, 
        // created_at: Math.floor(this.$api.license.signupTimestamp.getTime()/1000), //サインアップ日時を上書き
        // company:{company_id: this.$api.license.tenantId, name:this.$api.license.tenantName, Plan:this.$api.license.isTrial ? 'Trial':'Paid'},
        // TenantAdmin: this.$api.license.isTenantAdmin //インターコム側で管理者判定が必要
      };

      let script2 = document.createElement('script');
      script2.async = true
      script2.src = 'https://widget.intercom.io/widget/e1fkao87';
      document.head.appendChild(script2);      
  }    

  public onLogout(){
    this.$api.auth.logout();

  }
  public onExec(){
    //固定値
    this.query.generateSampleData = true; //サンプルデータあり
    this.query.provisioningTemplate = null; //標準固定

    //テナント作成が完了したらテナントにリダイレクトする
    //同一ドメインでの運用が前提にあるのでサブドメインを置換すれば良い
    //★ログインURLは選択せずに進めるようにしたい
    //★エラーが発生した場合に表示されて止まるかどうか確認する
    if (this.editor.validator.validate()){
      this.$api.startWaitCusor();
      this.$api.execute(this.query)
      .then( obj => {
        this.$api.closeWaitCursor();
        var result = obj as SignupResult;
        //this.isSignup = result.success == false; 成功時のダイアログを廃止
        //this.result = result.message;
       
        //成功した場合はsignupイベントをタグマネージャーに送信する
        if (result.success){
          // if (this.contract) (window as any).dataLayer.push({'event': 'billed'});     //有償利用開始
          // else (window as any).dataLayer.push({'event': 'signup'}); //無料トライアル開始
          if (this.contract) this.$api.issueGA4eventCommon({'event': 'billed','tenantId': this.query.tenantId});     //有償利用開始
          else this.$api.issueGA4eventCommon({'event': 'signup','tenantId': this.query.tenantId}); //無料トライアル開始
                    
          //そのままリダイレクト          
          this.onSuccess();
        } else {
          //失敗した場合はメッセージを表示
          this.result = result.message;
        }     
      });
    }
  }
  public onSuccess(){
    if (this.contract)location.href=location.origin.replace('contract',this.query.tenantId);
    else location.href=location.origin.replace('signup',this.query.tenantId);
  }
  public onCardCreatedPayJP(arg:any){
    this.query.info = new Common.PaymentInfoPayJP();
    this.query.info.name = arg.card.name;
    this.query.info.brand = arg.card.brand;
    this.query.info.last4 = arg.card.last4;
    this.query.info.exp_month = arg.card.exp_month;
    this.query.info.exp_year = arg.card.exp_year;
    this.query.info.token = arg.id;
    this.query.info.cvc_check = arg.card.cvc_check;
    this.card_info = String.format("xxxx-xxxx-xxxx-{0}", arg.card.last4);
  }  
}
